module.exports = __webpack_public_path__ + "img/130.4c1dd8da.jpg";